
import QRCode from 'qrcode';
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
  props: {
    isLoadingDone: Boolean,
    buttonUrl: String,
    logoGuid: String,
  },
  methods: {
    openPitchYouTab() {
      const url = 'https://www.pitchyou.de'; // URL, die geöffnet werden soll
      window.open(url, '_blank');
    },
  },
  setup(props) {
    const targetUrl = ref('');
    const useWindowOpen = ref(true);
    const qrCodeUrl = ref('');
    const logoPath = ref('/api/media/v1/logo/');

    const openUrl = () => {
      if (props.buttonUrl) {
        if (useWindowOpen.value) {
          window.open(props.buttonUrl, '_blank');
        } else {
          window.location.href = props.buttonUrl;
        }
        useWindowOpen.value = !useWindowOpen.value;
      }
    };

    const generateQRCode = async () => {
      if (props.buttonUrl) {
        try {
          const url = await QRCode.toDataURL(props.buttonUrl, {
            color: { dark: '#000', light: '#fcf5eb' },
            width: 250,
            margin: 2,
          });
          qrCodeUrl.value = url;
        } catch (error) {
          console.error('Fehler beim Generieren des QR-Codes:', error);
        }
      }
    };

    watch(
      () => props.buttonUrl,
      (newButtonUrl) => {
        targetUrl.value = newButtonUrl ?? '';
      }
    );

    watch(
      () => props.buttonUrl,
      (newVal) => {
        if (newVal) {
          generateQRCode();
        }
      },
      { immediate: true }
    );

    return {
      openUrl,
      targetUrl,
      qrCodeUrl,
      logoPath,
    };
  },
});
